import { animated, to } from 'react-spring';
import styled from 'styled-components';
import images from '../../../images';

const CardContainer = styled(animated.div)`
  overflow-y: hidden;
  position: fixed;
  width: 85%;
  overflow-x: hidden;
  height: 50%;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 85%;
  max-height: 62%;
  will-change: transform;
  border-radius: 10px;
  box-shadow:
  2px 2px 10px 2px rgba(0, 0, 0, 0.2);
`;

const MaterialImage = styled.img`
  height: 40vh;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const MaterialName = styled.h2`
  text-align: center;
  font-size: 3.33vh;
  margin-top: 5%;
  margin-bottom: 5%;
  transform: translateY(-25px);
`;

const MaterialDetails = styled(animated.div)`
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 94%;
  max-height: 100%;
  will-change: transform;
  border-radius: 10px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 1%;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  transform: translate(50%, -50%);
`;

const ButtonImage = styled.img`
  height: 7vh;
  width: 7vh;
  border-radius: 50%;
  background-color: #efefef;
  background-size: contain;
  background-position: center;
  display: block;
  margin: 0 auto;
  border: 1px solid black;
`;

/**
 * This component includes name and image of a material in a card with two buttons
 * for selecting recyclable or not recycable options
 * Also this component includes a function for transformation while user swipe ot to roght or left
 *
 */

const Card = ({
  i, x, y, rot, scale, trans, bind, objs, onSwipeRight, onSwipeLeft
}) => {
  const { mat_nm, mat_image } = objs[i];

  return (
    <CardContainer
      key={i}
      style={{
        transform: to(
          [x, y],
          // eslint-disable-next-line no-shadow
          (x, y) => `translate3d(${x}px,${y}px,0)`
        ),
        display: 'flex'
      }}
    >
      <MaterialDetails
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...bind(i)}
        style={{
          transform: to([rot, scale], trans),
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div>
          <MaterialImage
            src={mat_image}
            alt={mat_nm || 'Material image'}
          />
          <MaterialName>{mat_nm}</MaterialName>
          {/* <ButtonsContainer>
            <ButtonImage alt="not recyclable image" src={images.decline} onClick={onSwipeLeft} />
            <ButtonImage alt="recyclable image" src={images.recycable} onClick={onSwipeRight} />
          </ButtonsContainer> */}
        </div>
      </MaterialDetails>
    </CardContainer>
  );
};

export default Card;
